import request from "./axios";

/**
 * 获取用户信息
 */
export function getUserInfo(){
    return request({
        url: "/api/teaching/user/info",
        method: "get"
    })
}

/**
 * 获取用户信息
 */
export function getUserDetail(){
    return request({
        url: "/api/teaching/user/detail",
        method: "get"
    })
}

/**用户统计数据 */
export function userCountInfo(){
    return request({
        url: "/api/teaching/user/countInfo",
        method: "get"
    })
}

/**
 * 解绑微信
 */
export function unbindWechat(){
    return request({
        url: "/api/wechat/userWechat/unbindWechat",
        method: "get"
    })
}

/**
 * 我的奖杯
 */
export function mineAward(){
    return request({
        url: "/api/teaching/teachingAward/mineAward",
        method: "get"
    })
}


// WEBPACK FOOTER //
// ./src/api/user.js